/**
 * Inicializaión de la clase DocumentModel, modelo del documento de identificación
 *
 * *Set DocumentModel class, id document model*
 *
 * @access public
 * @type {class}
 */
export class DocumentModel {
  /**
   * Tipo de documento de identifiación del usuario
   *
   * *User's id document type*
   *
   * @type {number} id
   */
  document_type: string;

  /**
   * Número de la carta de indentificación del usuario
   *
   * *User's identification card numbert*
   *
   * @type {string} card_number
   */
  card_number?: string;

  /**
   * Número de indentificación del usuario mostrado en el documento de indentificación
   *
   * *User's identification number showed in the document*
   *
   * @type {string} document_number
   */
  document_number: string;

  /**
   * Primer apellido del usuario mostrada en el documento
   *
   * *User's first lastname showed in the document*
   *
   * @type {string} primary_lastname
   */
  primary_lastname: string;

  /**
   * Segundo apellido del usuario mostrada en el documento
   *
   * *User's second lastname showed in the document*
   *
   * @type {string} second_lastname
   */
  second_lastname: string;

  /**
   * Primer nombre del usuario mostrada en el documento
   *
   * *User's first name showed in the document*
   *
   * @type {string} firstname
   */
  firstname: string;

  /**
   * Segundo nombre del usuario mostrada en el documento
   *
   * *User's middle name showed in the document*
   *
   * @type {string} middlename
   */
  middlename: string;

  /**
   * Género del usuario mostrada en el documento
   *
   * *User gender showed in the document*
   *
   * @type {string} sex
   */
  sex: string;

  /**
   * Fecha de nacimiento mostrada en el documento
   *
   * *birthdate showed in the document*
   *
   * @type {string} birthdate
   */
  birthdate: string;

  /**
   * Tipo de sangre mostrada en el documento
   *
   * *Blood type showed in the document*
   *
   * @type {string} rh
   */
  rh?: string;

  /**
   * Huella dactilar del documento
   *
   * *Document's finger printed*
   *
   * @type {number} finger_printed
   */
  finger_printed: number;

  /**
   * Imagen posterior del documento de identidad
   *
   * *Back document picture*
   *
   * @type {string} back_document_picture
   */
  back_document_picture?: string;

  /**
   * Código de barras del documento
   *
   * *document's bar code*
   *
   * @type {string} bar_code
   */
  bar_code?: string;

  /**
   * Fecha de expedición del documento
   *
   * *document issued date*
   *
   * @type {string} date_of_issue
   */
  date_of_issue?: string;

  /**
   * Ciudad de expedición del documento
   *
   * *document issued city*
   *
   * @type {string} issued_city
   */
  issued_city?: string;

  /**
   * Departamento de expedición del documento
   *
   * *document issued department*
   *
   * @type {string} issued_department
   */
  issued_department?: string;
  /**
   * telefonos
   *
   * *phones numbers*
   *
   * @type {string} issued_department
   */
  phones?: any[];
  /**
   * Correo electronico
   *
   * *email*
   *
   * @type {string} issued_department
   */
  email?: string;
}
